module.exports = __webpack_public_path__ + "static/media/yopen-recoveryEmailSent.d9ec09a7.svg";